import { graphql, readInlineData } from "react-relay";

import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { checkIsPlusPage } from "~/components/pages/plus-pages/helpers";
import { checkIsPostiesPage } from "~/components/pages/posties-pages/helpers";
import type { helpersAppBarVariantBase$key } from "~/queries/__generated__/helpersAppBarVariantBase.graphql";

export type Application = "scmp" | "posties" | "plus";

export const getApplication = (reference: helpersAppBarVariantBase$key): Application => {
  const content = readInlineData(
    graphql`
      fragment helpersApplicationBase on Base @inline {
        ...helpersCheckIsPostiesArticle
        ...helpersCheckIsPostiesPage
        ...helpersCheckIsPlusPage
      }
    `,
    reference,
  );

  if (checkIsPostiesArticle(content) || checkIsPostiesPage(content)) return "posties";
  if (checkIsPlusPage(content)) return "plus";

  return "scmp";
};
